/*
 * Logout.ts
 * Description: Sends a request to destroy
 * the JWT, hence, to log out the user
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Log out the user
 *
 * @return {Object} Promise - whether logging out has been successful
 */
export function postLogout() {
    const jwt = localStorage.getItem('jwt');
    // Creating a new instance of Promise to make JavaScript work synchronous
    return new Promise ((resolve, reject) => {
        // Creating an HTTP request to refresh jwt token
        Axios({
            url:  APIURL + 'auth/logout',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then(() => {
            // Removing 'jwt' and 'expireDate' from local memory if user is not logged.
            localStorage.clear();
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
